import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import CircularProgress from 'material-ui/CircularProgress';

import { GetUserMe, SetAuthTokenCookie, DelAuthTokenCookie, SetHttpDefaultHeaders } from '../http/AuthService';
import Snackbar from "material-ui/Snackbar";

import { grey700, grey500 } from 'material-ui/styles/colors';

import { environment } from '../../environment';

const qs = require('query-string');

class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            requesting: false,
            snackbarOpen: false,
            snackbarMsg: ""
        }
    }

    showSnackbarMessage = message => {
        this.setState({ snackbarOpen: true, snackbarMsg: message });
    };

    handleSnackbarClose = () => {
        this.setState({ snackbarOpen: false });
    };

    componentDidMount() {
        const search = qs.parse(this.props.location.search);

        if (search.token) {
            this.setState({ requesting: true });

            const { cookies } = this.props;

            DelAuthTokenCookie(cookies);

            SetHttpDefaultHeaders(search.token);

            GetUserMe()
                .then(result => {
                    const user = result.data;
                    SetAuthTokenCookie(cookies, search.token);
                    this.props.updateUser(user);
                })
                .catch(err => {
                    this.showSnackbarMessage("" + err);
                    this.setState({ requesting: false });
                })
        }
        else {
            if (!this.props.auth && !this.props.logoff) {
                window.location.assign(environment.authUrl);
            }
        }
    }

    render() {
        const { requesting } = this.state;

        return (
            <div style={{ textAlign: 'center', padding: 40 }}>
                {this.props.auth ? <Redirect to='/scheduler' /> : ""}

                <div style={{ fontSize: 16, fontWeight: 'bold', color: grey700 }}>
                    Agendador de Tarefas
                </div>

                <div style={{ fontSize: 14, color: grey500, marginTop: 20 }}>
                    Módulo de controle de tarefas agendadas de todos os produtos

                    <div style={{ marginTop: 22 }}>
                        <a target="_blank" href="https://gorillascode.com/" rel="noopener noreferrer">
                            <img src="https://s3-sa-east-1.amazonaws.com/gorillascode-assets/gorillas.png" alt="logo" />
                        </a>
                    </div>
                </div>

                {requesting &&
                    <div style={{ marginTop: 30, color: grey500 }}>
                        <CircularProgress />
                        <p style={{ fontSize: 12 }}>Carregando usuário</p>
                    </div>
                }

                <Snackbar
                    open={this.state.snackbarOpen}
                    message={this.state.snackbarMsg}
                    autoHideDuration={3000}
                    onRequestClose={this.handleSnackbarClose}
                />
            </div>
        );
    }
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/view/Home.js